import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card'
import LoginForm from './LoginForm'
import { GoogleOAuthProvider } from '@react-oauth/google'

import useGetSocialAppId from '@/services/api/auth/useGetSocialAppId.ts'
import GoogleLogin from './GoogleLogin'
import FacebookLoginButton from './FacebookLoginButton'
import { useState } from 'react'
import { TwoFactorChallengePage } from './TwoFactorChallengePage'
import useAuthStore from '@/store/useAuthStore'
import { motion, AnimatePresence } from 'framer-motion'

export default function LoginPage() {
  const [googleAuthInProgress, setGoogleAuthInProgress] = useState(false)
  const [facebookAuthInProgress, setFacebookAuthInProgress] = useState(false)
  const showTwoFactorChallenge = useAuthStore(
    (state) => state.showTwoFactorChallenge,
  )

  const { data: googleApp, isLoading: isLoadingGoogleApp } = useGetSocialAppId({
    platform: 'google',
  })
  function onSuccess() {}

  if (isLoadingGoogleApp) return 'Loading...'

  return (
    <div className="grid min-h-screen">
      <div className="place-self-center">
        <AnimatePresence mode="wait">
          {!showTwoFactorChallenge ? (
            <motion.div
              key="login"
              initial={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2, ease: 'easeOut' }}
            >
              <Card>
                <CardHeader>
                  <CardTitle>Sign in to your account</CardTitle>
                </CardHeader>
                <CardContent
                  className={
                    googleAuthInProgress || facebookAuthInProgress
                      ? 'pointer-events-none animate-pulse'
                      : ''
                  }
                >
                  <div className="grid gap-3">
                    <GoogleOAuthProvider clientId={googleApp?.platform_id}>
                      <GoogleLogin
                        isLoading={googleAuthInProgress}
                        setIsLoading={setGoogleAuthInProgress}
                      />
                    </GoogleOAuthProvider>
                    <FacebookLoginButton
                      isLoading={facebookAuthInProgress}
                      setIsLoading={setFacebookAuthInProgress}
                    />
                  </div>

                  <div className="my-4 flex items-center gap-4 text-txt-secondary">
                    <hr className="flex-1" /> <span>or</span>{' '}
                    <hr className="flex-1" />
                  </div>

                  <LoginForm onSuccess={() => onSuccess} />
                </CardContent>
              </Card>
            </motion.div>
          ) : (
            <motion.div
              key="tfa"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.2, ease: 'easeIn' }}
            >
              <TwoFactorChallengePage />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  )
}
